import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50f03772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "app__title" }
const _hoisted_3 = { class: "app__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "app__disclaimer" }, " This calculator is designed to provide estimations of shipping costs and times. These may vary depending on the weight of the pack or commercial vale, and the destination. ")
], -1))

import { useMyStore } from '@/v2/store';
import ShippingDetailsV2 from '@/v2/ShippingDetailsV2.vue';
import ExamplePacks from '@/components/ExamplePacks.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppV2',
  setup(__props) {

const store = useMyStore();

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: _unref(store).loading > 0
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('title')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ShippingDetailsV2, { class: "app__shipping-details" }),
          _createVNode(ExamplePacks, { class: "app__example-packs" })
        ]),
        _hoisted_4
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})